import { readContract, writeContractAndWait } from "../viem";
import MafiaPerkBoxClaimAbi from "../../abis/MafiaPerkBoxClaim.json";
import config from "../../config/config";

const address = config.perkBoxClaim;
const abi = MafiaPerkBoxClaimAbi;

export const claimPerkBoxes = async (
  account: string,
  itemIds: number[],
  ogNFTAmount: number,
  signMsg: string,
  signature: string
) => {
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "claimPerkBoxes",
    args: [itemIds, ogNFTAmount, JSON.stringify(signMsg), signature],
    account,
  });

  return tx;
};

export const getHasClaimedRankPerk = async (account: string) => {
  const hasClaimedRankPerk: boolean = await readContract({
    address,
    abi,
    functionName: "hasClaimedRankPerk",
    args: [account],
  });

  return hasClaimedRankPerk;
};

export const getHasClaimedPremiumPerk = async (account: string) => {
  const hasClaimedPremiumPerk: boolean = await readContract({
    address,
    abi,
    functionName: "hasClaimedPremiumPerk",
    args: [account],
  });

  return hasClaimedPremiumPerk;
};
